<div class="container-fluid">
    <div class='container-shadow px-3 pb-4 pt-3' *ngIf='!loading'>
        <h2 class='pb-3 text-center'>Processing scan</h2>
        <div class="row">        
            <div class="col-md-7">
                <iframe 
                    *ngIf='!isScanFininshed'
                    frameborder="1" 
                    height="1100" 
                    id="pdfFrame" 
                    scrolling="auto" 
                    style="border:1px solid #777ccc" 
                    title="PDF in an i-Frame" 
                    width="100%"
                    [src]="scan.iframeUrl | safeUrl"
                    id="scan-preview">
                </iframe>
                <h3 *ngIf='isScanFininshed' class='text-center card py-5' style='min-height: 300mm;'>We cannot display a finished scan</h3>
            </div>
            <div class="col-md-5">
                <div class="alert alert-info" *ngIf="intakeReleaseContext && intakeReleaseContext.item_id">
                    <h5>Intake Source</h5>
                    <p class="mb-1" *ngIf="intakeReleaseContext.source_context">
                        <strong>Source:</strong> {{intakeReleaseContext.source_context}}
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.original_filename">
                        <strong>Original file:</strong>
                        <a
                            *ngIf="intakeReleaseContext.source_file_url"
                            [href]="intakeReleaseContext.source_file_url"
                            target="_blank"
                            rel="noopener">
                            {{intakeReleaseContext.original_filename}}
                        </a>
                        <span *ngIf="!intakeReleaseContext.source_file_url">{{intakeReleaseContext.original_filename}}</span>
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.requested_document_name">
                        <strong>Requested name:</strong> {{intakeReleaseContext.requested_document_name}}
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.original_email_url">
                        <strong>Original email:</strong>
                        <a [href]="intakeReleaseContext.original_email_url" target="_blank" rel="noopener">Open original email</a>
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.submitted_by">
                        <strong>Submitted by:</strong> {{intakeReleaseContext.submitted_by}}
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.apparent_author">
                        <strong>Apparent author:</strong> {{intakeReleaseContext.apparent_author}}
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.suggested_document_type">
                        <strong>Suggested type:</strong> {{intakeReleaseContext.suggested_document_type}}
                        <span *ngIf="intakeReleaseContext.classification_confidence">({{intakeReleaseContext.classification_confidence}})</span>
                    </p>
                    <p class="mb-1" *ngIf="intakeReleaseContext.classification_reason">
                        <strong>Reason:</strong> {{intakeReleaseContext.classification_reason}}
                    </p>
                    <p class="mb-0" *ngIf="intakeReleaseContext.status">
                        <strong>Status:</strong> {{intakeReleaseContext.status}}
                    </p>
                    <details class="mt-2" *ngIf="intakeReleaseContext.status_events && intakeReleaseContext.status_events.length">
                        <summary>Status history</summary>
                        <ul class="mb-0 pl-3 small">
                            <li *ngFor="let event of intakeReleaseContext.status_events">
                                <strong>{{event.status}}</strong>
                                <span *ngIf="event.at"> - {{event.at}}</span>
                                <span *ngIf="event.user_name"> - {{event.user_name}}</span>
                                <span *ngIf="event.detail">: {{event.detail}}</span>
                            </li>
                        </ul>
                    </details>
                </div>
                <div class="row" *ngIf='areDatesPresent'>
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            <h3 class="text-center">
                                ALERT!!!!  There are dates in the scan.  More than one date means there is a good chance an event will need to be created!
                            </h3>
                            <details class="text-center mt-3">
                                <summary>{{scanDates.length}} dates found</summary>
                                <ul class="mt-2 mb-0 pl-0" style="list-style-type:none;">
                                    <li *ngFor="let date of scanDates">{{date}}</li>
                                </ul>
                            </details>
                        </div>
                    </div>
                </div>
                <form>
                    <div class="form-group row">
                        <label for="matter-name" class="col-sm-2 col-form-label">Matter(s)</label>
                        <div class="col-sm-10">
                            <app-matter-search 
                                id="matter-name" 
                                [placeholder]="'Search and select'"  
                                [small_input]="false" 
                                [include_item]="true"
                                [select_only]="true" 
                                (matter)="onMatterSelect($event)"></app-matter-search>                            
                            <div *ngFor="let matter of matters; let l = last;">
                                <a href="#" [ngClass]="{'text-danger': !deletingMatter, 'text-muted': deletingMatter}" class="text-danger float-right" title="Remove matter" (click)="$event.preventDefault();deleteMatter(matter.id)"><i class="fas fa-trash-alt" aria-hidden="true"></i></a>
                                <a [routerLink]="'/matters/' + matter.id" target="_blank">{{matter.label}}</a>
                                <hr *ngIf='!l' />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="doc-type" class="col-sm-2 col-form-label">Doc Type</label>
                        <div class="col-sm-10">
                            <app-document-type-tree-select
                                id="document-type"
                                [placeholder]="'Filter document types'"
                                [maxHeight]="300"
                                [documentTypeId]="scan.document_type_id"
                                (document_type_id)="onDocumentTypeSelect($event)"
                                (clearDocumentType)="clearDocumentType()"></app-document-type-tree-select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="author" class="col-sm-2 col-form-label">Author(s)</label>
                        <div class="col-sm-10">
                            <input
                                type="text"
                                class="form-control"
                                [(ngModel)]='newScanAuthor'
                                [typeahead]="availableAuthors"
                                (typeaheadOnSelect)="onAuthorSelect($event.item)"
                                typeaheadOptionField="list_name"
                                name="scan_new_author_search"
                                placeholder="Search and select"
                                />
                            <div *ngFor="let scanAuthor of authors; let l = last;">
                                <a href="#" [ngClass]="{'text-danger': !deletingAuthor, 'text-muted': deletingAuthor}" class="text-danger float-right" title="Remove matter" (click)="$event.preventDefault();deleteAuthor(scanAuthor)"><i class="fas fa-trash-alt" aria-hidden="true"></i></a>
                                <a [routerLink]="'/contacts/' + scanAuthor.contact_id" target="_blank">{{scanAuthor.list_name}}</a>
                                <hr *ngIf='!l' />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="authored-on" class="col-sm-2 col-form-label">Authored On</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" name="authored-on" [(ngModel)]="scan.authored_on" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="scan.authored_on = $event" id="authored-on" />
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="intakeReleaseContext.spreadsheet">
                        <label class="col-sm-2 col-form-label">Save as</label>
                        <div class="col-sm-10">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="spreadsheet-release-both" name="spreadsheet-release-format" value="both" [(ngModel)]="scan.spreadsheet_release_format">
                                <label class="form-check-label" for="spreadsheet-release-both">Spreadsheet and PDF (default)</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="spreadsheet-release-spreadsheet" name="spreadsheet-release-format" value="spreadsheet" [(ngModel)]="scan.spreadsheet_release_format">
                                <label class="form-check-label" for="spreadsheet-release-spreadsheet">Spreadsheet only</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="spreadsheet-release-pdf" name="spreadsheet-release-format" value="pdf" [(ngModel)]="scan.spreadsheet_release_format">
                                <label class="form-check-label" for="spreadsheet-release-pdf">PDF only</label>
                            </div>
                            <small class="form-text text-muted">The original spreadsheet is preserved. PDF copies use an automatically selected readable print layout.</small>
                        </div>
                    </div>
                    <div class="form-group row" *ngIf="documentType.is_expense || documentType.is_check">
                        <label for="amount" class="col-sm-2 col-form-label">Amount</label>
                        <div class="col-sm-10">
                        <input type="number" class="form-control" id="amount" [(ngModel)]="scan.amount" name="amount">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="tags" class="col-sm-2 col-form-label">Tags</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" id="tags" [(ngModel)]="scan.tags" name="tags">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="exhibit-number" class="col-sm-2 col-form-label">Exhibit Number</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" id="exhibit-number" [(ngModel)]="scan.exhibit" name="exhibit-number">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="notes" class="col-sm-2 col-form-label">Notes</label>
                        <div class="col-sm-10">
                            <textarea id="notes" cols="30" rows="4" class="form-control" [(ngModel)]="scan.notes" name="notes"></textarea>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-10">
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="form-check mr-4" (click)='scan.has_problems = !scan.has_problems'>
                                    <input class="form-check-input" type="checkbox" id="has-problems" [checked]="scan.has_problems" name="has-problems">
                                    <label class="form-check-label" for="has-problems">
                                        This scan has problems
                                    </label>
                                </div>
                                <div class="form-check" *ngIf="isScanProcessing">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        id="skip-rules"
                                        name="skip-rules"
                                        [(ngModel)]="scan.skip_rules">
                                    <label class="form-check-label" for="skip-rules">
                                        Skip Rules
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="form-group row" *ngIf='scan.has_problems && isScanProcessing'>
                        <label for="notes" class="col-sm-2 col-form-label">Problem</label>
                        <div class="col-sm-10">
                            <textarea id="notes" cols="30" rows="10" class="form-control" [(ngModel)]="scan.problems" name="problems"></textarea>
                        </div>
                    </div>
                    <div *ngIf="!isScanProcessing">
                        <div class="row">
                            <div class="col-md-4"></div>
                            <div class="col-md-7">
                                <h4>Releaser's Comments</h4>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-4"></div>
                            <div class="col-md-7 text-danger">
                                <div id="problems-html-content" class="text-danger" [innerHTML]="scan.problems | safeHtml"></div>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                        <div *ngIf="isScannerReviewing">
                            <div class="row">
                                <div class="col-md-4">
                                    Scanner's Response
                                </div>
                                <div class="col-md-8">
                                    <textarea class="form-control" id="scanner-form-response" name="scanner-form-response" cols="63" rows="5" placeholder="Respond only if you disagree." [(ngModel)]="scan.scanner_response"></textarea>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isAttorneyReviewing">
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div class="col-md-7">
                                    <h4>Scanner's Response</h4>
                                </div>
                                <div class="col-md-1"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div class="col-md-7 text-danger" id="scanner-response" [innerHTML]="scan.scanner_response | safeHtml"></div>
                                <div class="col-md-1"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    Attorney's Response
                                </div>
                                <div class="col-md-8">
                                    <textarea class="form-control" id="attorney-form-response" name="attorney-form-response" cols="63" rows="5" placeholder="Respond only if you disagree." [(ngModel)]="scan.attorneyResponse"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class='py-2'></div>
                        <div class="row">
                            <div class="col-sm-4 mb-4">
                                <button 
                                    class="btn btn-primary" 
                                    [disabled] = "accepting || !(matters.length > 0) || !(authors.length > 0) || !scan.document_type_id || !scan.authored_on"
                                    (click)="accept()">
                                        <span *ngIf="!accepting">
                                            Accept as is
                                        </span>
                                        <span *ngIf='accepting'>
                                            Accepting&nbsp;<i class="fas fa-spinner fa-spin"></i>
                                        </span>
                                    </button>
                            </div>
                            <div class="col-sm-4 mb-4" *ngIf="!isAttorneyReviewing">
                                <button 
                                    class="btn btn-primary" 
                                    (click)="save('updated')"
                                    [disabled]="saving || !(matters.length > 0) || !(authors.length > 0) || !scan.document_type_id || !scan.authored_on">
                                    <span *ngIf="!saving">
                                        Respond
                                    </span>
                                    <span *ngIf="saving">
                                        Responding&nbsp;<i class="fas fa-spinner fa-spin"></i>
                                    </span>
                                </button>
                            </div>
                            <div class="col-sm-4 mb-4" *ngIf="isAttorneyReviewing">
                                <button 
                                    class="btn btn-primary" 
                                    (click)="save('attorney')"
                                    [disabled] = "saving || !(matters.length > 0) || !(authors.length > 0) || !scan.document_type_id || !scan.authored_on">
                                    <span *ngIf="!saving">
                                        Respond
                                    </span>
                                    <span *ngIf="saving">
                                        Responding&nbsp;<i class="fas fa-spinner fa-spin"></i>
                                    </span>
                                </button>
                            </div>                            
                            <div class="col-sm-4 mb-4">
                                <a type="button" 
                                   class="btn btn-danger" 
                                   [href]="'/scans?priority=' + scan.priority + '&cancelled=' + scan.id">
                                   Cancel
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row justify-content-center" *ngIf="isScanProcessing">
                        <div class="col-sm-auto mb-2 px-1">
                            <button 
                                type="button" 
                                class="btn btn-primary" 
                                 [disabled]="saving || matters.length < 1 || authors.length < 1 || !scan.document_type_id || !scan.authored_on"
                                (click)="save('released')">
                                <span *ngIf='!saving'>
                                    Release
                                </span>
                                <span *ngIf='saving'>
                                    Releasing&nbsp;<i class="fas fa-spinner fa-spin"></i>
                                </span>
                            </button>
                        </div>
                        <div class="col-sm-auto mb-2 px-1">
                            <a type="button" 
                               class="btn btn-danger" 
                               [href]="'/scans?priority=' + scan.priority + '&cancelled=' + scan.id">
                               Cancel
                            </a>
                        </div>
                        <div class="col-sm-auto mb-2 px-1">
                            <button 
                                type="button" 
                                class="btn btn-danger" 
                                (click)="deleteScanConfirm()"
                                [disabled]="deleting">
                                <span *ngIf='!deleting'>
                                    Delete
                                </span>
                                <span *ngIf='deleting'>
                                    Deleting&nbsp;<i class='fa fa-spinner fa-spin'></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>    
    <div class='container-shadow p-3 py-5 text-center' *ngIf='loading'>
        <i class='fa fa-spinner fa-spin fa-5x'></i>
    </div>
</div>

<ng-template #confirmDeleteModal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">Confirm deletion</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="deleteWarningMessage | safeHtml"></p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
      <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
    </div>
  </ng-template>
